export const COLUMN_WIDTH = {
  AUTHOR: 200,
  TYPE: 200,
} as const
